import { Component } from '@angular/core';

/**
 * Temporal bargraph icon component declaration, responsible for displaying the icon for temporal-bar-graph in vis-type selection
 */
@Component({
  selector: 'mav-temporal-bargraph-icon',
  templateUrl: './temporal-bargraph-icon.component.html',
  styleUrls: ['./temporal-bargraph-icon.component.scss']
})
export class TemporalBargraphIconComponent { }
